import {InvoiceBillTo} from './ExportInvoiceModal.type';

/** One option in the legacy-path Client dropdown, as ExportInvoiceButton builds it. */
export type QuickbooksCustomerOption = {value: string; label: string; realmId: string | null};

/*
 * Where an export goes. The pathways window knows it from the bill-to; the legacy window from the
 * client chosen in its header. Every "which integration / what input" question the modal asks goes
 * through this, so the two windows share one component. T4-155 adds the Xero CLIENT variant.
 */
export type ExportTarget =
	| {kind: 'BILL_TO'; billTo: InvoiceBillTo}
	| {
			kind: 'CLIENT';
			integration: string;
			/** Null until a client is chosen. */
			clientId: string | null;
			/** Null when the client carries no realm: a single-connection company. */
			realmId: string | null;
	  };

export const getTargetIntegration = (target: ExportTarget | null): string | null => {
	if (!target) return null;
	return target.kind === 'BILL_TO' ? target.billTo.billFrom?.integration ?? null : target.integration;
};
